__turbopack_context__.v({
  "card": "cube-module__kKU1La__card",
  "cardNumeral": "cube-module__kKU1La__cardNumeral",
  "cardTitle": "cube-module__kKU1La__cardTitle",
  "cardTrack": "cube-module__kKU1La__cardTrack",
  "controls": "cube-module__kKU1La__controls",
  "controlsGhost": "cube-module__kKU1La__controlsGhost",
  "cover": "cube-module__kKU1La__cover",
  "ctrlBtn": "cube-module__kKU1La__ctrlBtn",
  "cube-idle": "cube-module__kKU1La__cube-idle",
  "depth": "cube-module__kKU1La__depth",
  "face": "cube-module__kKU1La__face",
  "faceLink": "cube-module__kKU1La__faceLink",
  "faceNumeral": "cube-module__kKU1La__faceNumeral",
  "grid": "cube-module__kKU1La__grid",
  "gridSquare": "cube-module__kKU1La__gridSquare",
  "root": "cube-module__kKU1La__root",
  "scrim": "cube-module__kKU1La__scrim",
  "spinner": "cube-module__kKU1La__spinner",
  "squareStage": "cube-module__kKU1La__squareStage",
  "stage": "cube-module__kKU1La__stage",
  "viewport": "cube-module__kKU1La__viewport",
});
